import loadable from '@loadable/component';

export const ApplicationHistoryPageContainerLoadable = loadable(
  () => import('./ApplicationHistoryPageContainer'),
  { resolveComponent: (module) => module.ApplicationHistoryPageContainer },
);
